import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const DeleteFoodCategoriesSlice = createSlice({
    name: "deleteFoodCategoriesRequest",
    initialState,
    reducers: {
        deleteFoodCategoriesRequest(state) {
            state.loading = true;
        },
        deleteFoodCategoriesRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        deleteFoodCategoriesRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        deleteFoodCategoriesStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    deleteFoodCategoriesRequest,
    deleteFoodCategoriesRequestSuccess,
    deleteFoodCategoriesRequestError,
    deleteFoodCategoriesStateReset,
} = DeleteFoodCategoriesSlice.actions;

export default DeleteFoodCategoriesSlice.reducer;
